module.exports = __webpack_public_path__ + "img/confetti.1de7db5e.svg";